<header-with-menu></header-with-menu>

<section class="font-sans text-xl py-10 px-5 text-center">
    <p class="mb-4">Oops! We had a technical error. Our team is working to fix it right now.</p>
    <p class="mb-4">Please call {{ phoneNumber }} to ensure request processed correctly.</p>
    <p class="mb-4">We apologize for any inconvenience. Thank you for trusting Terra Mare!</p>
</section>
